import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Toast } from '../models';



@Injectable({
  providedIn: 'root'
})
export class SharedService {
  public eventSidenav:EventEmitter<boolean> = new EventEmitter<boolean>();
  public eventSidenavMobile:EventEmitter<boolean> = new EventEmitter<boolean>();
  public eventCreateToaster:EventEmitter<Toast> = new EventEmitter<Toast>();
 
  constructor(
    private http:HttpClient
  ) { }

  public searchAutocomplete(url:string, value:string) : Observable<any> {
    return this.http.get<any>(`${url}?q=${value}`);
  }
}
